export enum LicenseStrings {
  Namespace = 'bookingSetting',
  BookingPolicyLabelTextKey = 'bookingConditionsLabel',
  BookingPolicyTextKey = 'bookingConditions',
  ServiceCostsTextKey = 'serviceCosts',
}
